import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API } from '../../api';

@Injectable({
    providedIn: 'root'
})
export class MeasurementUnitService {
    private url: string = API + '/measurement-unit';

    constructor(private http: HttpClient) { }

    getMeasurementUnits(): Observable<any> {
        return this.http.get(this.url);
    }
}
